module.exports = __webpack_public_path__ + "static/media/node.c443bd7e.png";